// src/components/Navbar.js

import React from 'react';
import { Link } from 'react-router-dom'; // Importar para navegação entre páginas
import '../styles/navbar.scss'; // Estilos da Navbar

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo da aplicação */}
        <img 
          src={`${process.env.PUBLIC_URL}/assets/logo_unef.svg`} 
          alt="Logo" 
          className="navbar-logo" 
        /><div class="navbar-text">Gerenciador De Polos</div>
      </div>
      
    </nav>
  );
};

export default Navbar;
